import { useMemo } from "react";

import { MsalAccountContext } from "@dfp/react-msal-support";
import {
  APIProvider,
  APIRequestorIdentityProvider,
  makeRequestorIdentityDefault,
} from "@dfp/react-api-core";

import { DEMO_USER, demoMsalAccount } from "./demoMsalAccount.ts";

type Props = {
  children: React.ReactNode;
};

export function DemoUserAuthProvider({ children }: Props) {
  // DEMO_USER.username is always a non-empty constant, so the default identity
  // is never null here.
  const requestorIdentity = useMemo(
    () => makeRequestorIdentityDefault(DEMO_USER.username)!,
    [],
  );

  return (
    <MsalAccountContext.Provider value={demoMsalAccount}>
      <APIProvider>
        <APIRequestorIdentityProvider requestorIdentity={requestorIdentity}>
          {children}
        </APIRequestorIdentityProvider>
      </APIProvider>
    </MsalAccountContext.Provider>
  );
}
